import {Action, ActionReducer} from '@ngrx/store';
import {CommonActionType} from './common.action';
import {AppState, initialAppState} from '../app.state';

export function commonMetaReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state: AppState, action: Action) => {
    if (action.type === CommonActionType.CLEAR_ALL) {
      return initialAppState;
    }

    return reducer(state, action);
  };
}
